import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './metricInstrumentsGrid.module.scss';
export const MetricInstrumentsGrid = ({ bounded = false, fluid = false, children, }) => {
    const rootClass = classnames(styles.root, {
        [styles.rootBounded]: bounded,
        [styles.rootFluid]: fluid,
    });
    return _jsx("div", Object.assign({ className: rootClass }, { children: children }));
};
